import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ViewProductDetailsService {
    
  constructor(private _http: HttpClient) { }

    getdetail(data) {
        return this._http.post(environment.api_url+'admin/getproduct/details',data);
    }

  templatestatus(data) {
    return this._http.post(environment.api_url+'admin/addproduct/updatestatus',data);
  }

  searchcategory(data) {
    return this._http.post(environment.api_url+'searchcategory',data);
  }

    updatecategory(data) {
        return this._http.post(environment.api_url+'admin/addproduct/updatecategory',data);
    }

    getsellerlisting(data) {
        return this._http.post(environment.api_url+'admin/product/sellerlistingbyproduct',data);
    }

}
